import type { TReplaceOptions } from 'cng-common/features/translations/components/translation/models/replaceOptions'

import type { AcknowledgmentPrimaryAction } from '../model/types'
import { ACKNOWLEDGMENT_STATUS_DIALOG_TRANSLATION_KEYS } from '../translations'

export const getPrimaryBannerText = (
  primaryAction: AcknowledgmentPrimaryAction,
  fallbackSigner: string
): {
  key: string
  replaceParams?: TReplaceOptions[]
} => {
  if (!primaryAction) {
    return {
      key: ACKNOWLEDGMENT_STATUS_DIALOG_TRANSLATION_KEYS.primaryBanner.signRequired,
    }
  }

  if (primaryAction.kind === 'sign') {
    return {
      key: ACKNOWLEDGMENT_STATUS_DIALOG_TRANSLATION_KEYS.primaryBanner.signRequired,
    }
  }

  return {
    key: ACKNOWLEDGMENT_STATUS_DIALOG_TRANSLATION_KEYS.primaryBanner.awaitingAcknowledgment,
    replaceParams: [
      {
        key: '{signer}',
        value: primaryAction.item.SignerName ?? primaryAction.item.SignerEmail ?? fallbackSigner,
      },
    ],
  }
}
